module.exports = __webpack_public_path__ + "static/media/archero2_logo_cn@2x.022042a4.png";